import { Navigate } from 'react-router';
import { useAuth } from '../hooks/useAuth';
import { useT } from '../i18n';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
    const { user, loading } = useAuth();
    const t = useT();

    if (loading) {
        return (
            <div className="loading-screen">
                <div className="spinner" />
                <p>{t.common_loading}</p>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/auth" replace />;
    }

    return <>{children}</>;
}
